import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-itams.component.scss?ngResource";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationItamsConstants } from "./create-application-location-itams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { debounceTime } from "rxjs";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { CreateApplicationDetailsItamsConstants } from "../create-application-details-itams/create-application-details-itams.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let CreateApplicationLocationItamsComponent = class CreateApplicationLocationItamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    searchApplicationsService;
    mapComponent;
    activeTabIndex; // The active tab index is zero based that is, the first tab has an index of 0 instead of 1
    baysForm;
    previousApplicationValidated = false;
    descriptionLabel1 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationItamsConstants.VALIDATION_MESSAGES;
    baysFormGroupName = CreateApplicationLocationItamsConstants.BAYS_FORM_GROUP_NAME;
    baysFormControlName = CreateApplicationLocationItamsConstants.BAYS_FORM_CONTROL;
    addressControl = CreateApplicationLocationItamsConstants.ADDRESS_CONTROL;
    bayNumberControl = CreateApplicationLocationItamsConstants.BAY_NUMBER_CONTROL;
    baySizeControl = CreateApplicationLocationItamsConstants.BAY_SIZE_CONTROL;
    addressTextPlaceHolder = CreateApplicationLocationItamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    bayNumberPlaceHolder = CreateApplicationLocationItamsConstants.BAY_NUMBER_PLACEHOLDER;
    baySizeTextPlaceHolder = CreateApplicationLocationItamsConstants.BAY_SIZE_TEXT_PLACEHOLDER;
    removeBayLabel = CreateApplicationLocationItamsConstants.REMOVE_BAY_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    layerReference = CreateApplicationLocationItamsConstants.LAYER_REF;
    selectedBaySubscription;
    selectedApplicationLocationItamsSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    getBays() {
        return this.baysForm.get(this.baysFormControlName);
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.setupSubscribers();
        this.isPreviousApplicationValidated();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionBayEnabled = true;
    }
    mapLoaded() {
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionBayEnabled = false;
    }
    loadMetadata() {
    }
    onBtnRemoveSelectedBayClicked(bayIndex) {
        const previousActiveIndex = this.activeTabIndex;
        this.getBays().removeAt(bayIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
        if (previousActiveIndex === bayIndex && bayIndex > 0) {
            this.activeTabIndex = bayIndex - 1;
        }
        else if (previousActiveIndex > bayIndex) {
            this.activeTabIndex = previousActiveIndex - 1;
        }
    }
    initForm() {
        this.baysForm = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
    }
    syncMapGeometries() {
        const geometries = [];
        this.getBays().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
        }
    }
    setupSubscribers() {
        this.subscribeToSelectedBaysOnTheMap();
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    if (this.previousApplicationValidated) {
                        this.appController.showMessage(CreateApplicationLocationItamsConstants.CLEARED_VALIDATION_MESSAGE, AlertType.Warning);
                    }
                    else {
                        this.getBays().clear();
                        this.mapComponent.removeGraphicsFromMap(this.layerReference);
                        this.mapTools.sketchGraphicsLayer.removeAll();
                        this.changeDetectorRefs.detectChanges();
                    }
                }
            }
        });
    }
    subscribeToSelectedBaysOnTheMap() {
        this.selectedBaySubscription = this.mapService.$selectedBay.pipe(debounceTime(1000)).subscribe(selectedMapFeature => {
            if (selectedMapFeature !== null) {
                this.setBayData(selectedMapFeature.attributes, selectedMapFeature.geometry);
            }
        });
    }
    setBayData(bayObject, geometry) {
        try {
            const detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
            const applicationValidated = detailsForm.get("previousApplicationValidated").value;
            if (applicationValidated) {
                this.mapComponent.removeGraphicsFromMap(this.layerReference);
                this.mapTools.sketchGraphicsLayer.removeAll();
                this.changeDetectorRefs.detectChanges();
                return;
            }
            this.requestStatusService.showBusySpinner("SetBayData");
            const bayNumber = CreateApplicationUtils.propertyDataAlternateColumnName(bayObject, "BayNumber", "baynumber");
            let found = false;
            this.getBays().controls.forEach(item => {
                const check = item.get(this.bayNumberControl).value;
                if (check === bayNumber) {
                    found = true;
                    this.appController.showMessage(CreateApplicationLocationItamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                    this.requestStatusService.removeBusySpinner("SetBayData");
                }
            });
            if (!found) {
                const newBay = new FormGroup({
                    id: new FormControl(0),
                    objectId: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(bayObject, "OBJECTID", "objectid")),
                    address: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(bayObject, "Address", "address"), [Validators.required]),
                    geometry: new FormControl(geometry),
                    bayNumber: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(bayObject, "BayNumber", "baynumber"), [Validators.required]),
                    baySize: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(bayObject, "Size", "size"), [Validators.required]),
                    centroid: new FormControl(null, [Validators.required])
                });
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometry));
                this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData)
                    .subscribe((trueCentroidResponse) => {
                    newBay.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    const bayControl = this.getBays();
                    bayControl.push(newBay);
                    this.activeTabIndex = bayControl.length - 1;
                    this.changeDetectorRefs.detectChanges();
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetBayDate");
                });
            }
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("SetBayData");
        }
    }
    isPreviousApplicationValidated() {
        const detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
        this.previousApplicationValidated = detailsForm.get("previousApplicationValidated").value;
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationLocationItamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData(this.selectedApplication);
            }
        });
    }
    updateComponentData(selectedApplication) {
        const savedApplicationBays = selectedApplication.bays;
        const detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
        const applicationValidated = detailsForm.get("previousApplicationValidated").value;
        const savedApplicationBaysFormArray = this.baysForm.get(this.baysFormControlName);
        savedApplicationBaysFormArray.clear();
        if (savedApplicationBays && savedApplicationBays.length > 0) {
            savedApplicationBays.forEach((applicationBay) => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(applicationBay.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                let formGroup;
                if (applicationValidated) {
                    formGroup = new FormGroup({
                        id: new FormControl(applicationBay.id),
                        bay: new FormControl(applicationBay),
                        address: new FormControl({ value: applicationBay.address, disabled: true }),
                        geometry: new FormControl(geom),
                        bayNumber: new FormControl({ value: applicationBay.bayNumber, disabled: true }),
                        baySize: new FormControl({ value: applicationBay.baySize, disabled: true }),
                        centroid: new FormControl(null, [Validators.required])
                    });
                }
                else {
                    formGroup = new FormGroup({
                        id: new FormControl(applicationBay.id),
                        bay: new FormControl(applicationBay),
                        address: new FormControl(applicationBay.address, [Validators.required]),
                        geometry: new FormControl(geom),
                        bayNumber: new FormControl(applicationBay.bayNumber),
                        baySize: new FormControl(applicationBay.baySize),
                        centroid: new FormControl(null, [Validators.required])
                    });
                }
                // savedApplicationBaysFormControl.push(formGroup);
                this.setTrueCentroid(geometryArc, formGroup, savedApplicationBaysFormArray);
            });
        }
    }
    setTrueCentroid(geometryArc, newBayFormGroup, bayFormArray) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                if (response && response.results) {
                    newBayFormGroup.get("centroid").setValue(response.results[0].value);
                    bayFormArray.push(newBayFormGroup);
                    this.activeTabIndex = 0;
                }
                else {
                    if (response.error) {
                        this.appController.showMessage(`Something went wrong with the application.Please contact administrator: ${response.error.message}`, AlertType.Error);
                    }
                }
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationItamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationItamsComponent);
export { CreateApplicationLocationItamsComponent };
